import React from 'react';
import { useParams } from 'react-router-dom';
import AccountSettingsTab from 'components/accounts/AccountSettingsTab';
import Accounts from 'pages/accounts/Accounts';

const AccountsLayout = () => {
  const { id } = useParams();

  if (id) {
    return <AccountSettingsTab />;
  }

  return <Accounts />;
};

export default AccountsLayout;
